/** Different methods of gathering user input */
export enum TwilioGatherType {
    DTMF = 'dtmf',
    Speech = 'speech',
    'DTMF Speech' = 'dtmf speech'
}